import {ChangeDetectorRef, Component, Input, OnInit, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {FileObj, ICRUDOverrides, ICRUDRecord, IResource, IResourceUpload, IUser, IZivud, UploadStatus} from "../../../interfaces";
import {AppService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {actionAddResources, actionLoadDynawebsEquipment, actionLoadDynawebsEquipmentReply, actionSaveDynawebsEquipment, actionSaveDynawebsEquipmentSuccess, actionSaveFailedDynawebsEquipment} from "../../../store/actions/user.actions";
import {copyTextClipboard, EQUIP_ACCESS, formatBytes, isHostLocal, isNullOrUndefOrEmpty, LIMIT_UPLOADS_COUNT, restrictSingleQuote, SUPPORTED_FILE_TYPES} from "../../../common";
import {TranslocoService} from '@ngneat/transloco';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Lib} from 'libs/Lib';
import {catchError, map, take, timeout} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";
import {ofType} from "@ngrx/effects";
import {ActionsSubject} from "@ngrx/store";
import {HttpClient} from "@angular/common/http";
import * as _ from "lodash";
import * as Papa from 'papaparse';
import {MatInput} from "@angular/material/input";
import {faGun, faHandcuffs, faPersonRifle, faWalkieTalkie} from '@fortawesome/free-solid-svg-icons';

/**
 * link to edit vehicles:
 * https://docs.google.com/spreadsheets/d/15_ImnRy-a-zOzen78AQ-2nlL72ew-g2dali2jPFYzek/edit?gid=0#gid=0
 */

enum EnumViewMode {
    NOT_LOGGED_IN,
    CHECKING_1,
    CHECKING_2,
    COMPLETED,
}

interface TableData {
    name: string;
    value: string;
}

interface IFileInfo {
    fileId: string;
    fileSize: number;
    progress: number;
}

@Component({
    selector: 'app-equipped',
    templateUrl: './equipped.component.html',
    styleUrls: ['./equipped.component.scss']
})
export class EquippedComponent extends Compbaser implements OnInit {
    @Input() category = '';
    @ViewChild("uploadModal", {read: TemplateRef}) uploadModal: TemplateRef<any>;
    @ViewChild("problemSaving", {read: TemplateRef}) problemSaving: TemplateRef<any>;
    @ViewChildren('inputBox') inputBoxes!: QueryList<MatInput>;

    debugMode = false;

    private readonly IMAGE_MAX_SIZE_MB = 1.5;
    private readonly IMAGE_COMPRESS: boolean = true;

    // Tracks how many images are in the middle of being compressed:
    imagesBusyCount = 0;

    // Controls whether the button 'לסיכום' is disabled:
    lesikumDisabled = true;

    viewMode: EnumViewMode = EnumViewMode.NOT_LOGGED_IN;
    startCheckDisabled = true;
    wizardDisabled1 = true;
    wizardDisabled2 = true;
    imageData: string[] = [];
    userName = '';
    officerId = '';
    email = '';
    selectedCaptain: any;
    selectedVehicle: any;
    selectedCodeCall: any;
    dateNow: string;
    form: FormGroup;
    filesUploaded = [];
    uploadModalRef: MatDialogRef<any>;
    m_user: IUser;
    lastZivud: IZivud;
    uploading = false;
    uploadPercentage = 0;
    totalFileSize = 0;
    formattedTotalSize = '0 Byte';
    formattedUploadingSize = '0 Byte';
    selectedFiles: Array<FileObj> = [];
    copyFileObjects: Array<IFileInfo> = [];
    version = '11.40';
    studioId = '';
    kitatKonenut = false;
    maxNaznaz = _.range(0, 7).map(String);
    sheetUrl = `https://docs.google.com/spreadsheets/d/15_ImnRy-a-zOzen78AQ-2nlL72ew-g2dali2jPFYzek/export?format=csv`;
    emailSendTo = [{name: 'יוחאי', email: 'yohayl1707@gmail.com'}];
    displayedColumns: string[] = ['value', 'name'];
    equipmentSummary: TableData[] = [];
    missingEquipmentSummary = [];
    isDisabledLogin = false;
    inputControls = Array(6).fill(null);
    inputValues = ['', '', '', '', '', ''];
    inputValuesReady = false;
    leftCheckboxes: string[] = [];
    rightCheckboxes: string[] = [];
    faGun = faGun;
    faPersonRifle = faPersonRifle;
    faHandcuffs = faHandcuffs;
    faWalkieTalkie = faWalkieTalkie;

    debouncedProblemSavingDialog: (err: string) => void;
    protected readonly EnumViewMode = EnumViewMode;

    vehicles = [
        {id: '25-168', zivud: true},
        {id: '25-288', zivud: true},
        {id: '25-001', zivud: true},
        {id: '25-845', zivud: true},
        {id: '25-848', zivud: true},
        {id: '25-916', zivud: true},
        {id: '25-944', zivud: true},
        {id: '11-743', zivud: true},
        {id: '24-349', zivud: true},
        {id: '19-103', zivud: false},
        {id: '11-403', zivud: false},
        {id: '14-914', zivud: false},
        {id: '466-28-802', zivud: false},
        {id: '17-568', zivud: false}
    ];

    levIds: string[] = [...Array.from({length: 200}, (_, i) => (400 + i).toString() + ' לב '), '000'];
    avivIds: string[] = [...Array.from({length: 100}, (_, i) => (300 + i).toString() + ' אביב ')];
    callIds: string[];

    overrideCredentials: ICRUDOverrides = {
        user: 'zivudlev@gmail.com',
        password: 'policelev@',
        webApiBaseUrl: 'https://ida.signage.me',
        businessId: '627453'
    };

    inv = [
        // -------------------------------------------------------
        // (A) OTHER (not validated by wizard1 or wizard2)
        // -------------------------------------------------------
        {name: 'date', place: '', maxStock: null, value: this.getDate(), addToReport: 0, equipmentSummary: 0},
        {name: 'הערות', place: 'wizard2', value: 0, addToReport: 0, equipmentSummary: 0},

        // -------------------------------------------------------
        // (B) WIZARD1 (place: 'wizard1')
        // -------------------------------------------------------
        // Some items also have checkPage1: 1 for your step-1 logic
        {name: 'אפוד_קרמי', place: 'wizard1', maxStock: 2, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'אפוד_מגן', place: 'wizard1', maxStock: 2, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'קסדה', place: 'wizard1', maxStock: 2, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'אלה', place: 'wizard1', maxStock: 2, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'תיק_פיזור', place: 'wizard1', maxStock: 2, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'תיק_מחסומים', place: 'wizard1', maxStock: 1, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'תיק_סיור', place: 'wizard1', maxStock: 1, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'תיק_שטח', place: 'wizard1', maxStock: 1, value: '0', checkPage1: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מספר_נשק', place: 'wizard1', maxStock: 1, checkLength: 2, checkPage1: 1, addToReport: 0, equipmentSummary: 1},
        {name: 'מספר_נשק2', place: 'wizard1', maxStock: 1, addToReport: 0, equipmentSummary: 1},
        {name: 'אזיק_רגליים', place: 'wizard1', maxStock: 1, addToReport: 0, equipmentSummary: 1},
        {name: 'מספר_טייזר', place: 'wizard1', maxStock: 1, addToReport: 0, equipmentSummary: 1},
        {name: 'מספר_טאבלט', place: 'wizard1', maxStock: 1, checkLength: 2, checkPage1: 1, addToReport: 0, equipmentSummary: 1},
        {name: 'מספר_קשר1', place: 'wizard1', maxStock: 1, checkLength: 2, checkPage1: 1, addToReport: 0, equipmentSummary: 1},
        {name: 'מספר_קשר2', place: 'wizard1', maxStock: 1, addToReport: 0, equipmentSummary: 1},

        // -------------------------------------------------------
        // (C) WIZARD2 (place: 'wizard2')
        // -------------------------------------------------------
        // Marked with checkPage2: 1 => validated in step 2
        {name: 'סדר', place: 'wizard2', value: '?', checkPage2: 1, addToReport: 0, equipmentSummary: 0},
        {name: 'קילומטראז', place: 'wizard2', value: 0, checkPage2: 1, checkLength: 3, addToReport: 0, equipmentSummary: 0},
        {name: 'גשר_תאורה_מהבהב', place: 'wizard2', maxStock: 1, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מחסום_סטינגר_דוקרנים', place: 'wizard2', maxStock: 2, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'טרפזים', place: 'wizard2', maxStock: 8, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'אוהל_מחסום', place: 'wizard2', maxStock: 2, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'בדיקת_אומים', place: 'wizard2', maxStock: 20, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מגפון', place: 'wizard2', maxStock: 1, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מתודלקת', place: 'wizard2', maxStock: 100, value: '0%', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'חומס', place: 'wizard2', maxStock: 2, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'נצנצים_קימים', place: 'wizard2', maxStock: 6, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'נצנצים_טעונים', place: 'wizard2', maxStock: 6, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'ססל', place: 'wizard2', maxStock: 5, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'יריעה_לגופה', place: 'wizard2', maxStock: 2, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'חליפת_סערה', place: 'wizard2', maxStock: 2, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},

        // Wizard2 left group => multiCheckLeft:1
        {name: 'ערכת_עזרה_ראשונה', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מטף_כיבוי_לרכב', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מגבה_לרכב_ידית_מפתח', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'גלגל_ספייר', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'אפודה_זוהרת', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'משולש_אזהרה', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מערכת_כריזה', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מערכת_קשר', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},

        // Wizard2 right group => multiCheckRight:1
        {name: 'עמדת_עריסה', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מכשיר_נייד_מיקרופון', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מצלמת_רוורס', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מדפסת_נייר', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מגבר_צופר_רמקול_מיקרופון', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'adblue', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'נורת_בדוק_מנוע', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'נורת_בדוק_מצבר', place: 'wizard2', maxStock: 1, value: '0', multiCheckRight: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מערכת_כריזה', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {name: 'מערכת_קשר', place: 'wizard2', maxStock: 1, value: '0', multiCheckLeft: 1, checkPage2: 1, addToReport: 1, equipmentSummary: 0},

        // 'טיהור_תא_עצורים' also in wizard2 checks
        {name: 'טיהור_תא_עצורים', place: 'wizard2', maxStock: 1, value: '', checkPage2: 1, addToReport: 0}
    ];

    constructor(
        private fb: FormBuilder,
        private renderer: Renderer2,
        private http: HttpClient,
        private appService: AppService,
        private actionsSubj: ActionsSubject,
        private toastr: ToastrService,
        private translocoService: TranslocoService,
        private cd: ChangeDetectorRef,
        private localStoreService: LocalStoreService,
        public storeSelector: StoreSelectorsService,
        dialog: MatDialog
    ) {
        super(dialog);
        this.setMe('equipped-component');
        console.log('equipment running version: ' + this.version);
        this.callIds = [...this.levIds, ...this.avivIds];
        this.appService.checkAppVersion().then((v) => {
            console.log('equipment checked version ' + v);
        });

        this.debouncedProblemSavingDialog = _.debounce((err: string) => {
            this.problemSavingDialog(err);
        }, 1500);

        /*** Toggle debug if local as well as codeCall = 000 for full test mode ***/
        if (isHostLocal()) {
            // this.setDebugging();
        }

        // Load Google Sheet data
        this.fetchSheetData().subscribe({
            next: (data) => {
                // Attempt to parse email + vehicles from Google Sheet
                const sheetData = data;
                const pattern = /^\s*(?:([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,})\s+(.*)|(.+)\s+([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}))\s*$/;
                try {
                    this.emailSendTo = [];
                    if (Array.isArray(sheetData) && sheetData.length > 5) {
                        sheetData.forEach((item) => {
                            if (item?.email) {
                                const match = item.email.match(pattern);
                                if (match) {
                                    let email = match[1] || match[4];
                                    let name = match[2] || match[3];
                                    email = email.trim();
                                    name = name.trim();
                                    this.emailSendTo.push({name, email});
                                }
                            }
                            if (item?.vehicles && item?.vehicles.length > 4) {
                                this.vehicles.push({
                                    id: item.vehicles,
                                    zivud: item.vizud?.toLowerCase()
                                });
                            }
                        });
                    }
                } catch (e) {
                    this.emailSendTo = [{name: 'יוחאי', email: 'yohayl1707@gmail.com'}];
                    console.error('problem building google sheet list');
                }
                this.vehicles = _.uniqBy(this.vehicles, 'id');
            },
            error: (err) => console.error('Error fetching sheet data:', err),
        });

        // Listen for lastZivud data from store
        this.cod(
            this.actionsSubj.pipe(ofType(actionLoadDynawebsEquipmentReply))
                .subscribe((reply) => {
                    if (isNotNullOrUndefined(reply?.payload?.vehicleId)) {
                        this.lastZivud = reply.payload;
                    }
                })
        );

        const date = new Date();
        this.dateNow = date.toLocaleString('he-IL', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });

        this.createForm();

        // Re-hydrate from local storage
        this.userName = isNullOrUndefOrEmpty(
            this.localStoreService.getStorageValConfig('equipmentUser')
        )
            ? ''
            : this.localStoreService.getStorageValConfig('equipmentUser');
        this.officerId = isNullOrUndefOrEmpty(
            this.localStoreService.getStorageValConfig('equipmentId')
        )
            ? ''
            : this.localStoreService.getStorageValConfig('equipmentId');

        const acc = isNullOrUndefOrEmpty(
            this.localStoreService.getStorageValConfig('equipmentAccess')
        )
            ? ''
            : this.localStoreService.getStorageValConfig('equipmentAccess');
        if (acc?.length > 4) {
            this.onLoginCheck(acc);
        }

        if (this.debugMode) {
            this.setDebugging();
        }
    }


    ngOnInit() {
        this.renderer.setAttribute(document.body, 'translate', 'no');
        this.studioId = this.localStoreService.getStorageConfig().studioId;

        this.leftCheckboxes = this.inv
            .filter(item => item.multiCheckLeft === 1)
            .map(item => item.name);

        // Example: create rightCheckboxes
        this.rightCheckboxes = this.inv
            .filter(item => item.multiCheckRight === 1)
            .map(item => item.name);
    }


    changeMaxNaznaz(e) {
        this.maxNaznaz = _.range(0, Number(e.value) + 1).map(String);
    }

    createForm() {
        const formGroup = {};
        this.inv.forEach(item => {
            formGroup[item.name] = [item.value || '', this.getValidators(item)];
        });
        this.form = this.fb.group(formGroup);
    }

    private getValidators(item): Validators[] {
        const validators = [];
        if (item.maxStock !== undefined && item.maxStock !== null) {
            validators.push(Validators.max(item.maxStock));
        }
        return validators;
    }

    onSelectedCaptain() {
        // Placeholder if needed
    }

    onSelectedVehicle() {
        if (!this.selectedVehicle) return;
        // If a certain vehicle is not "zivud," skip wizard requirements
        if (this.selectedVehicle.zivud === false) {
            this.wizardDisabled1 = false;
            this.wizardDisabled2 = false;
        }
    }

    checkString(value, len): boolean {
        if (value === null) return false;
        const v = String(value);
        return typeof v === 'string' && v.length > len;
    }

    private updateLesikumButtonDisabledState(): void {
        // Disable if there are NO files or if some are still compressing
        this.lesikumDisabled = !(this.selectedFiles.length > 0 && this.imagesBusyCount === 0);
    }

    isDebugModeCodeCall() {
        if (this.selectedCodeCall === '000') {
            this.setDebugging();
            console.log(`selection ${this.debugMode} / ${this.version}`);
        }
    }

    checkStartCheckReady() {
        if (!isNotNullOrUndefined(this.selectedCaptain)) return false;
        if (!isNotNullOrUndefined(this.selectedVehicle)) return false;
        if (
            this.checkString(this.selectedVehicle.id, 4) &&
            this.checkString(this.officerId, 4) &&
            !isNullOrUndefOrEmpty(this.selectedCodeCall) &&
            this.checkString(this.userName, 1)
        ) {
            this.startCheckDisabled = false;
        } else {
            this.startCheckDisabled = true;
        }
    }

    private calcTotalSize() {
        this.totalFileSize = this.copyFileObjects.reduce((size, fileObj) => {
            return size + fileObj.fileSize;
        }, 0);
        this.formattedTotalSize = formatBytes(this.totalFileSize, 2);
    }

    private showUploadingWaitDialog() {
        this.copyFileObjects = this.selectedFiles.map((fileObj) => ({
            fileId: fileObj.fileId,
            fileSize: fileObj.fileSize,
            progress: fileObj.progress
        }));
        this.calcTotalSize();
        this.uploadPercentage = 0;
        this.formattedUploadingSize = '0 Byte';

        this.uploadModalRef = this.dialog.open(this.uploadModal, {
            height: '520px',
            width: '500px',
            panelClass: 'transparentDialog',
            data: {}
        });
    }

    private uploadSelectedFiles() {
        const validUploadFiles = this.selectedFiles.filter((fileObj) =>
            fileObj.uploadStatus === UploadStatus.READY || fileObj.uploadStatus === UploadStatus.FAILED
        );

        for (const fileObj of validUploadFiles) {
            const file: File = fileObj.file;
            const formData = new FormData();
            formData.append("thumbnail", file);

            const saveRecord: ICRUDRecord = {
                studioId: this.studioId,
                command: 'upload',
                primary: 'resource_id',
                table: 'resources',
                body: formData,
                id: null,
                overrideCredentials: this.overrideCredentials,
                options: {noStringify: true, reportProgress: true},
            };

            this.appService.uploadFileWithProcess(saveRecord, (i_crudReply) => {
                const reply = i_crudReply.serverReply;
                // Progress
                if (
                    i_crudReply.command === 'progress' ||
                    (reply && reply.hasOwnProperty('type') && !reply.hasOwnProperty('body'))
                ) {
                    if (reply['type'] === 1 && reply['total']) {
                        const percent = Math.round(
                            (100 * parseFloat(reply['loaded'])) / parseFloat(reply['total'])
                        );
                        fileObj.progress = percent < 100 ? percent : 100;
                    }
                    fileObj.uploadStatus = UploadStatus.INPROGRESS;
                } else {
                    // Completed or failed
                    if (!reply?.status) {
                        fileObj.progress = 0;
                        fileObj.uploadStatus = UploadStatus.FAILED;
                    } else {
                        fileObj.progress = 100;
                        fileObj.uploadStatus = UploadStatus.SUCCESS;
                        fileObj.fileId = reply['body'].id;
                    }
                    this.updateResource();
                }
                this.calcUploadingPercentage();
            });
        }
    }

    private async updateResource() {
        let uploadingNow = false;
        let duration = '0';

        for (const fileObj of this.selectedFiles) {
            if (fileObj.uploadStatus === UploadStatus.SUCCESS) {
                if (SUPPORTED_FILE_TYPES.indexOf(fileObj.fileType.toLowerCase()) === -1) {
                    continue;
                }
                // If it's video, get the duration
                if (fileObj.fileType.toLowerCase() === 'mp4') {
                    duration = await this.getVideoDuration(fileObj);
                }

                const updatedRes: IResourceUpload = {
                    resource_name: `${this.selectedVehicle.id}_${new Date()
                        .toISOString()
                        .replace(/[^0-9]/g, "")}`,
                    resource_type: fileObj.fileType,
                    default_player: this.storeSelector.getBlockLabelByFileType(
                        fileObj.fileType.toLowerCase()
                    ).id as any,
                    resource_total_time: duration,
                    resource_date_created: String(new Date().getTime()),
                    resource_date_modified: String(new Date().getTime()),
                    resource_bytes_total: String(fileObj.fileSize),
                    access_key: '0',
                    tree_path: this.category
                };

                const saveRecord: ICRUDRecord = {
                    studioId: this.studioId,
                    command: 'update',
                    primary: 'resource_id',
                    table: 'resources',
                    body: updatedRes,
                    id: fileObj.fileId,
                    overrideCredentials: this.overrideCredentials
                };

                fileObj.uploadStatus = UploadStatus.UPDATING;
                const urlImage = `https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business627453/resources/${String(
                    fileObj.fileId
                )}.${fileObj.fileType}`;
                this.filesUploaded.push(urlImage);

                this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                    if (!i_crudReply.serverReply.status) return;
                    updatedRes['resource_id'] = String(fileObj.fileId);
                    updatedRes['id'] = String(fileObj.fileId);
                    updatedRes['changelist_id'] = String(
                        i_crudReply.serverReply.changelist_id
                    );
                    this.storeSelector.dispatch(actionAddResources({data: updatedRes as IResource}));
                    this.deleteFile(fileObj.fileId);
                });
            }
            if (fileObj.uploadStatus === UploadStatus.INPROGRESS) {
                uploadingNow = true;
            }
        }

        this.uploading = uploadingNow;

        if (!uploadingNow) {
            this.closeUploadDialog();
            // Dispatch the final save with the server
            this.storeSelector.dispatch(
                actionSaveDynawebsEquipment({
                    payload: {
                        version: this.version,
                        report: this.missingEquipmentSummary,
                        files: this.filesUploaded,
                        dateTime: this.dateNow,
                        officerId: this.officerId,
                        vehicleId: this.selectedVehicle.id,
                        userName: this.userName,
                        codeCall: this.selectedCodeCall,
                        data: this.form.value,
                        emailUser: this.selectedCaptain.email,
                        debug: isHostLocal() ? 1 : 0
                    }
                })
            );

            // Listen for the save response (assumes you have a success/failure action for save)

            this.actionsSubj.pipe(
                ofType(actionSaveDynawebsEquipmentSuccess, actionSaveFailedDynawebsEquipment),
                timeout(this.debugMode ? 1 : 10000), // Wait for 10 seconds for a reply
                take(1),
                catchError(err => {
                    // Timeout occurred, so handle as a failure
                    this.debouncedProblemSavingDialog('timeout');
                    return of(null);
                })
            ).subscribe(reply => {
                if (reply && reply.payload && reply.payload.saved) {
                    // Success branch
                    this.toastr.success('שמר נתונים');
                    this.viewMode = EnumViewMode.COMPLETED;
                } else {
                    this.debouncedProblemSavingDialog('server');

                    // optional let server know of the issue so it deletes db entry
                    // this.storeSelector.dispatch(
                    //     actionSaveFailedRemoveDynawebsEquipment({
                    //         payload: {
                    //             version: this.version,
                    //             report: this.missingEquipmentSummary,
                    //             dateTime: this.dateNow,
                    //             officerId: this.officerId,
                    //             vehicleId: this.selectedVehicle.id,
                    //             userName: this.userName,
                    //             codeCall: this.selectedCodeCall,
                    //             data: this.form.value,
                    //             emailUser: this.selectedCaptain.email,
                    //             debug: isHostLocal() ? 1 : 0
                    //         }
                    //     })
                    // );
                }
                this.cd.detectChanges();
            });
        }
        this.cd.detectChanges();
    }

    private problemSavingDialog(i_err: string) {
        this.toastr.error('נתקלנו בבעיה אנא צלמו את הניידת ושימרו שוב', i_err, {timeOut: 10000});
        // Reset file statuses if needed
        this.selectedFiles.forEach(fileObj => {
            if (fileObj.uploadStatus === UploadStatus.FAILED) {
                fileObj.uploadStatus = UploadStatus.READY;
                fileObj.progress = 0;
            }
        });
        this.uploadModalRef = this.dialog.open(this.problemSaving, {
            height: '290px',
            width: '400px',
            data: {}
        });
        // optional
        // this.storeSelector.dispatch(
        //     actionSaveFailedDynawebsEquipment({
        //         payload: {
        //             version: this.version,
        //             report: this.missingEquipmentSummary,
        //             dateTime: this.dateNow,
        //             officerId: this.officerId,
        //             vehicleId: this.selectedVehicle.id,
        //             userName: this.userName,
        //             codeCall: this.selectedCodeCall,
        //             data: this.form.value,
        //             emailUser: this.selectedCaptain.email,
        //             debug: isHostLocal() ? 1 : 0
        //         }
        //     })
        // );;
    }

    private closeUploadDialog() {
        if (this.uploadModalRef) {
            this.uploadModalRef.close();
        }
        this.copyFileObjects = [];
    }

    private calcUploadingPercentage() {
        const uploadedFileSize = this.copyFileObjects.reduce((size, fileObj) => {
            const f = this.selectedFiles.find((_fileObj) => _fileObj.fileId === fileObj.fileId);
            let progress = 100;
            if (f) progress = f.progress;
            return size + fileObj.fileSize * progress;
        }, 0);
        this.formattedUploadingSize = formatBytes(uploadedFileSize / 100, 2);
        if (!this.totalFileSize || !uploadedFileSize) {
            this.uploadPercentage = 0;
        } else {
            this.uploadPercentage = Math.round(uploadedFileSize / this.totalFileSize);
        }
    }

    private async getVideoDuration(i_file: FileObj): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                const video = document.createElement('video');
                video.preload = 'metadata';
                video.onloadedmetadata = () => {
                    window.URL.revokeObjectURL(video.src);
                    resolve(Lib.ParseToFloatDouble(video.duration));
                };
                video.onerror = () => {
                    resolve(0);
                };
                video.src = URL.createObjectURL(i_file.file);
            } catch (e) {
                reject(e);
            }
        });
    }

    /**
     * This method compresses an image if it's above the maxSize threshold.
     * By default, we pass in `this.IMAGE_MAX_SIZE_MB * 1024 * 1024` as maxSize.
     * If ANY error occurs (in reading the file, in canvas, etc.), we fall back
     * to returning the ORIGINAL file uncompressed.
     */
    private async compressImageFile(
        file: File,
        maxSize = this.IMAGE_MAX_SIZE_MB * 1024 * 1024
    ): Promise<File> {
        // If compression is off or file is already below the limit, just return as is.
        if (!this.IMAGE_COMPRESS || file.size <= maxSize) {
            return file;
        }

        try {
            return await new Promise<File>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event: any) => {
                    try {
                        const img = new Image();
                        img.onload = () => {
                            try {
                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');
                                if (!ctx) {
                                    // If we fail to get context, fallback to original
                                    return reject(new Error('Canvas context not found.'));
                                }

                                // Draw original image into the canvas
                                canvas.width = img.width;
                                canvas.height = img.height;
                                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                                let quality = 0.92; // start near high quality

                                const attemptCompression = () => {
                                    const dataUrl = canvas.toDataURL('image/jpeg', quality);
                                    const byteString = atob(dataUrl.split(',')[1]);
                                    const arrayBuffer = new ArrayBuffer(byteString.length);
                                    const intArray = new Uint8Array(arrayBuffer);

                                    for (let i = 0; i < byteString.length; i++) {
                                        intArray[i] = byteString.charCodeAt(i);
                                    }
                                    const compressedBlob = new Blob([intArray], {type: 'image/jpeg'});

                                    // Check size
                                    if (compressedBlob.size <= maxSize || quality < 0.3) {
                                        // Good enough, or can't compress further
                                        const newFile = new File(
                                            [compressedBlob],
                                            file.name.replace(/\.\w+$/, '.jpg'),
                                            {type: 'image/jpeg', lastModified: Date.now()}
                                        );
                                        resolve(newFile);
                                    } else {
                                        // Decrease quality slightly and try again
                                        quality -= 0.05;
                                        attemptCompression();
                                    }
                                };

                                // Start the compression attempts
                                attemptCompression();
                            } catch (canvasErr) {
                                // If something breaks in the drawing process
                                reject(canvasErr);
                            }
                        };

                        img.onerror = (err) => reject(err);
                        img.src = event.target.result as string;
                    } catch (imgErr) {
                        reject(imgErr);
                    }
                };

                reader.onerror = (fileErr) => reject(fileErr);
                reader.readAsDataURL(file);
            });
        } catch (e) {
            // If ANYTHING goes wrong at all, we log if needed and return the original file.
            if (this.debugMode) {
                console.error('Error compressing file, returning original file:', e);
            }
            return file;
        }
    }


    /**
     * Helper to convert a File to a base64 dataURL (for preview, if needed).
     */
    private fileToDataURL(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result as string);
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    }

    /**
     *  Capture <input type="file" accept="image/*" capture="environment">
     *  Potentially compress each image if IMAGE_COMPRESS is true,
     *  then store for upload + create base64 previews.
     */
    async onFilesSelected(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        if (!input.files) return;

        for (const file of Array.from(input.files)) {
            // Respect your limit
            if (this.selectedFiles.length >= LIMIT_UPLOADS_COUNT) {
                this.toastr.warning(
                    this.translocoService.translate('toast.limitUploads', {}, this.translocoService.getActiveLang())
                );
                continue;
            }

            // 1) Start “busy” for compression
            this.imagesBusyCount++;
            this.updateLesikumButtonDisabledState(); // disable while compressing

            let finalFile: File = file;
            // 2) Try compressing:
            try {
                if (this.IMAGE_COMPRESS) {
                    finalFile = await this.compressImageFile(file);
                }
            } catch (e) {
                // If compression fails, fallback to original
                if (this.debugMode) {
                    console.error('Error compressing file, using original:', e);
                }
                finalFile = file;
            } finally {
                // 3) Done compressing – decrement
                this.imagesBusyCount--;
                this.updateLesikumButtonDisabledState();
            }

            // 4) Convert the finalFile to base64 preview
            const previewDataUrl = await this.fileToDataURL(finalFile);
            this.imageData.push(previewDataUrl);

            // 5) Create a FileObj to track upload progress
            const fileName = restrictSingleQuote(finalFile.name).split('.').slice(0, -1).join('.');
            const fileExt = finalFile.name.split('.').pop() || 'jpg';

            const obj: FileObj = {
                fileName,
                fileType: fileExt,
                file: finalFile,
                fileId: `${fileName}-${finalFile.lastModified}`,
                progress: 0,
                uploadStatus: UploadStatus.READY,
                formattedSize: formatBytes(finalFile.size, 2),
                fileSize: finalFile.size
            };

            this.selectedFiles.push(obj);
            this.cd.detectChanges();
        }

        // Final check after all files
        this.updateLesikumButtonDisabledState();
    }

    removeFile(index: number): void {
        this.imageData.splice(index, 1);
        this.selectedFiles.splice(index, 1);

        // <-- Call the same method used for recalculating the button's disabled state.
        this.updateLesikumButtonDisabledState();
    }

    uploadFiles() {
        if (!this.selectedFiles || this.selectedFiles.length === 0) {
            this.toastr.error('חסר צילום');
            return;
        }
        // If everything is already SUCCESS, do nothing
        if (
            this.selectedFiles.filter((obj) => obj.uploadStatus !== UploadStatus.SUCCESS).length === 0
        ) {
            return;
        }
        this.uploading = true;
        this.showUploadingWaitDialog();
        this.uploadSelectedFiles();
    }

    onSubmit() {
        this.createReport();
        this.uploadFiles();
    }

    resetFormControlsPage2() {
        setTimeout(() => {
            Object.entries(this.form.controls).forEach(([controlName, control]) => {
                // Example: if you need to reset wizard2 fields, adapt logic here
                if (controlName.includes('wizard2')) {
                    control.markAsPristine();
                    control.markAsUntouched();
                    control.updateValueAndValidity();
                }
            });
        }, 100);
    }

    allControlsAllWizardsCheck() {
        setTimeout(() => {
            this.allControlsTouchedPage1(null);
            this.allControlsTouchedPage2(null);
        }, 333);
    }

    allControlsTouchedPage1(triggeredName?: string): void {
        let ready = 0;

        // If the caller passes a specific control name, mark it as touched.
        if (triggeredName) {
            this.form.controls[triggeredName].markAsTouched();
        }

        // 1) Get all Wizard1 items that must be validated: checkPage1 === 1
        const wizard1Items = this.inv.filter(item => item.checkPage1 === 1);

        // 2) Loop each relevant item
        for (const item of wizard1Items) {
            const ctrlName = item.name;
            const control = this.form.controls[ctrlName];

            // If the item has a "checkLength" property, we enforce min length
            if (item.checkLength) {
                // Example: if checkLength is 2, we require at least length >= 2
                if (!this.checkString(control.value, item.checkLength)) {
                    ready++;
                    continue; // skip further checks for this item
                }
            } else {
                // If no "checkLength" is specified, require that user at least touched the field
                if (!control.touched) {
                    ready++;
                    continue;
                }
            }
        }

        // If any item fails, wizardDisabled1 = true (unless debugMode).
        this.wizardDisabled1 = (ready !== 0) && !this.debugMode;
    }


    allControlsTouchedPage2(triggeredName: string): void {
        let ready = 0;

        // If a caller passes `triggeredName`, mark that control as touched:
        if (triggeredName) {
            this.form.controls[triggeredName].markAsTouched();
        }

        // 1) Filter `inv` for items flagged with `checkPage2: 1`.
        const page2Items = this.inv.filter(item => item.checkPage2 === 1);

        // 2) Loop each relevant item:
        for (const item of page2Items) {
            const ctrlName = item.name;
            const control = this.form.controls[ctrlName];

            // (a) If the item has a "checkLength" property,
            //     ensure the string length >= checkLength
            if (item.checkLength) {
                if (!this.checkString(control.value, item.checkLength)) {
                    ready++;
                    continue; // skip further checks for this item
                }
            }
            // (b) Otherwise, just require that it's touched:
            else {
                if (!control.touched) {
                    ready++;
                    continue;
                }
            }
        }

        if (!this.debugMode) {
            this.wizardDisabled2 = (ready !== 0);
        }
    }


    reload() {
        window.location.reload();
    }

    fetchSheetData(): Observable<any[]> {
        return this.http.get(this.sheetUrl, {responseType: 'text'}).pipe(
            map((csvData) => {
                const parsedData = Papa.parse(csvData, {
                    header: true,
                    skipEmptyLines: true,
                });
                // Filter out empty rows
                return parsedData.data.filter((row) =>
                    Object.values(row).some((value) => value)
                );
            })
        );
    }

    formatSummaryDataToText(data: { name: string; value: any }[]): string {
        // 1) Set up an icon map for the field names you'll output
        const iconMap: Record<string, string> = {
            'ע"י': '👤',
            'קוד קריאה': '📌',
            'נידת': '🚔',
            'קילומטראז': '🚖',
            'מספר_נשק': '🔫',
            'מספר_נשק2': '🔫',
            'אזיק_רגליים': '🔗',
            'מספר_טייזר': '⚡',
            'מספר_טאבלט': '📱',
            'מספר_קשר1': '📻',
            'מספר_קשר2': '📻'

        };

        let result = '';

        // 2) Print top lines for user, code call, vehicle
        //    (i.e., "ע"י", "קוד קריאה", and "נידת"). Only once, no duplicates.
        result += `👤 ע"י: ${this.userName}\n`;           // e.g. ע"י: שחר
        result += `📌 קוד קריאה: ${this.selectedCodeCall}\n`; // e.g. 000
        if (this.selectedVehicle?.id) {
            result += `🚔 נידת: ${this.selectedVehicle.id}\n`;   // e.g. 25-168
        }

        // 3) Loop through data for the rest
        for (const item of data) {
            const fieldName = item.name ?? '';
            let fieldValue = item.value ?? '';

            // (a) Skip if we've already handled these top-line fields
            if (fieldName === 'ע"י' || fieldName === 'קוד קריאה' || fieldName === 'נידת') {
                // We printed them already, so continue
                continue;
            }

            // (b) Convert empty string or booleans
            if (fieldValue === '') fieldValue = '---';
            if (fieldValue === true) fieldValue = '1';
            if (fieldValue === false) fieldValue = '0';

            // (c) Find icon if it exists
            const icon = iconMap[fieldName] || '';

            // (d) Print line => e.g. "🔗 אזיק_רגליים: 77777"
            result += `${icon ? icon + ' ' : ''}${fieldName}: ${fieldValue}\n`;
        }

        // 4) Add any bottom lines you want
        // result += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
        result += `\n🚓 לזיווד: tinyurl.com/zivudim`;
        // result += `https://secure.digitalsignage.com/levtlv.html\n`;
        // result += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;

        // result += `📜 היסטורית זיוודים:\n`;
        // result += `https://secure.digitalsignage.com/levtlv.html\n`;
        // result += `https://galaxy.signage.me/signstudio/shopping-cart/equipment\n`;
        // result += `https://secure.digitalsignage.com/reportEquipment?days=3\n`;
        // result += `━━━━━━━━━━━━━━━━━\n`;

        return result;
    }


    // formatSummaryDataToText(data) {
    //     let result = ``;
    //     data.forEach(item => {
    //         const name = item.name ?? '';
    //         let value = item.value !== undefined ? item.value : '';
    //         if (value === 'f') {
    //             value = '---';
    //         } else if (value === 't') {
    //             value = 'קים';
    //         }
    //         if (value === '') {
    //             value = '---';
    //         }
    //         result += `${name}: ${value}\n`;
    //     });
    //     return result;
    // }

    copyTable() {
        const report = this.formatSummaryDataToText(this.equipmentSummary);
        copyTextClipboard(report);
        this.toastr.info('עכשיו הדבק סיכום ציוד לוואטסאפ');
    }

    onBackspace(event: Event, index: number): void {
        if (index > 0 && this.inputValues[index] === '') {
            const prevInput = this.inputBoxes.toArray()[index - 1][
                'nativeElement'
                ] as HTMLInputElement;
            prevInput.focus();
        }
    }

    clearInputs(): void {
        this.inputValues = ['', '', '', '', '', ''];
        const firstInput = this.inputBoxes.first['nativeElement'] as HTMLInputElement;
        firstInput.focus();
    }

    onInput(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        this.inputValues[index] = input.value;
        if (input.value.length === 1) {
            if (index < this.inputValues.length - 1) {
                const nextInput = this.inputBoxes.toArray()[index + 1][
                    'nativeElement'
                    ] as HTMLInputElement;
                nextInput.focus();
            }
        }
        this.inputValuesReady = this.inputValues.every(value => /^[0-9]$/.test(value));
    }

    onLoginCheck(v?: string) {
        let acc;
        if (v) {
            acc = v;
        } else {
            acc = this.inputValues.join('');
        }
        if (acc.toLowerCase() === EQUIP_ACCESS) {
            this.viewMode = EnumViewMode.CHECKING_1;
            this.localStoreService.setStorageValConfig('equipmentAccess', acc);
        }
    }

    start() {
        if (!this.selectedVehicle || !this.officerId) {
            this.toastr.warning('חסר נתונים');
            return;
        }
        if (this.selectedVehicle.id.length < 5 || this.officerId.length < 5) {
            this.toastr.warning('חסר נתונים');
            return;
        }
        this.viewMode = EnumViewMode.CHECKING_2;
        this.localStoreService.setStorageValConfig('equipmentUser', this.userName);
        this.localStoreService.setStorageValConfig('equipmentId', String(this.officerId));
        this.storeSelector.dispatch(actionLoadDynawebsEquipment({payload: this.selectedVehicle.id}));
    }

    getDate() {
        const date = new Date();
        return date.toLocaleString('he-IL', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    }

    setKitatKonenoot(e) {
        this.kitatKonenut = e.checked;
        // If "כיתת כוננות" is checked, optionally pre-fill certain fields
        if (this.kitatKonenut) {
            this.form.controls['מספר_נשק2'].disable();
            this.form.controls['אזיק_רגליים'].disable();
            this.form.controls['מספר_טייזר'].disable();
            this.form.controls['מספר_טאבלט'].disable();
            this.form.controls['מספר_קשר2'].disable();
            this.form.controls['מספר_קשר1'].setValue('000000');
            this.allControlsTouchedPage1('מספר_קשר1');
            this.form.controls['מספר_טאבלט'].setValue('000000');
            this.allControlsTouchedPage1('מספר_טאבלט');
            this.form.controls['מספר_נשק'].setValue('000000');
            this.allControlsTouchedPage1('מספר_נשק');
        } else {
            this.form.controls['מספר_נשק2'].enable();
            this.form.controls['אזיק_רגליים'].enable();
            this.form.controls['מספר_טייזר'].enable();
            this.form.controls['מספר_טאבלט'].enable();
            this.form.controls['מספר_קשר2'].enable();
            this.form.controls['מספר_קשר1'].setValue('');
            this.allControlsTouchedPage1('מספר_קשר1');
            this.form.controls['מספר_טאבלט'].setValue('');
            this.allControlsTouchedPage1('מספר_טאבלט');
            this.form.controls['מספר_נשק'].setValue('');
            this.allControlsTouchedPage1('מספר_נשק');
        }
    }

    installPwa() {
        this.localStoreService.setStorageValConfig('equipmentPwa', '1');
        this.appService.installPwa();
    }

    clearPwa() {
        this.localStoreService.setStorageValConfig('equipmentPwa', '0');
        this.localStoreService.setStorageValConfig('equipmentUser', '');
        this.localStoreService.setStorageValConfig('equipmentAccess', '');
        this.localStoreService.setStorageValConfig('equipmentId', '');
    }

    createReport() {
        this.missingEquipmentSummary = [];
        const added = [];
        this.equipmentSummary = [];

        // Optional: If you always want to show 'קוד קריאה' + 'נידת' at the top, push them now:
        this.equipmentSummary.push({name: 'ע"י', value: this.userName});
        this.equipmentSummary.push({name: 'קוד קריאה', value: this.selectedCodeCall});
        this.equipmentSummary.push({name: 'נידת', value: this.selectedVehicle.id});
        this.equipmentSummary.push({name: 'קילומטראז', value: this.form.controls['קילומטראז'].value});

        // 1) Loop over every key in the form
        for (const key of Object.keys(this.form.value)) {
            const invItem = this.inv.find(item => item.name === key);
            if (!invItem) continue; // skip if no match in `inv`

            // 2) If it's 'date' => skip
            if (key === 'date') continue;

            // 3) If it's 'הערות', sanitize and skip or push if needed
            if (key === 'הערות') {
                if (this.form.value['הערות']) {
                    try {
                        const dangerousPattern = /\b(?:eval|shell_exec|system|passthru|exec)\b|[./\\]/gi;
                        this.form.value['הערות'] = this.form.value['הערות'].replace(dangerousPattern, '');
                    } catch (e) {
                        console.error('problem regexp process comments');
                    }
                }
                // If you don’t want to push הערות to any summary, just continue
                continue;
            }

            // 4) Convert booleans to 1/0
            let currentStock = this.form.value[key];
            if (currentStock === true) currentStock = 1;
            if (currentStock === false) currentStock = 0;

            // 5) If item has equipmentSummary === 1 => push to equipmentSummary
            if (invItem.equipmentSummary === 1) {
                this.equipmentSummary.push({
                    name: invItem.name,
                    value: currentStock
                });
            }

            // 6) If addToReport === 1 => do missingEquipment logic
            if (invItem.addToReport === 1) {
                if (!added.includes(key)) {
                    if (invItem.maxStock != null) {
                        // parse if numeric
                        if (!isNaN(parseInt(currentStock))) {
                            currentStock = parseInt(currentStock, 10);
                        }
                        // if different => push missing
                        if (currentStock !== invItem.maxStock) {
                            added.push(key);
                            this.missingEquipmentSummary.push({
                                item: key,
                                expect: invItem.maxStock,
                                current: currentStock,
                                missing: invItem.maxStock - currentStock
                            });
                        }
                    }
                }
            }
        }
    }

    deleteFile(fileId) {
        const i = this.selectedFiles.findIndex((file) => file.fileId === fileId);
        if (i > -1) {
            this.selectedFiles.splice(i, 1);
            this.imageData.splice(i, 1);
            this.cd.detectChanges();
        }
    }

    private setDebugging() {
        this.debugMode = true;
        this.wizardDisabled1 = false;
        this.wizardDisabled2 = false;
        this.selectedCodeCall = '000';
        // For quick debug
        setTimeout(() => {
            this.selectedVehicle = this.vehicles[0];
            this.selectedCaptain = this.emailSendTo[0];
            this.selectedCodeCall = this.callIds[0];
            this.selectedCodeCall = '000';
        }, 1500);
    }


    masterToggleGroup(side: 'left' | 'right', isChecked: boolean) {
        const group = side === 'left' ? this.leftCheckboxes : this.rightCheckboxes;
        group.forEach((ctrlName) => {
            // Set child to 'true' or 'false'
            this.form.controls[ctrlName].setValue(isChecked);
            // Mark as touched if you need your wizard logic
            this.form.controls[ctrlName].markAsTouched();
        });
        this.allControlsTouchedPage2('');
    }

    isGroupAllChecked(side: 'left' | 'right'): boolean {
        const group = side === 'left' ? this.leftCheckboxes : this.rightCheckboxes;
        return group.every(ctrl => this.form.value[ctrl] === true);
    }

    isGroupIndeterminate(side: 'left' | 'right'): boolean {
        const group = side === 'left' ? this.leftCheckboxes : this.rightCheckboxes;
        const someChecked = group.some(ctrl => !!this.form.value[ctrl]);
        const allChecked = group.every(ctrl => !!this.form.value[ctrl]);
        return someChecked && !allChecked;
    }
}
